module.exports = __webpack_public_path__ + "bd8cc7b9.png";